const moment = require('moment');

function validateDateRange(start, end, format = 'YYYY-MM-DD') {
  const isValidStart = moment(start, format, true).isValid();
  const isValidEnd = moment(end, format, true).isValid();
  return isValidStart && isValidEnd;
}

function getFormattedDateMonthFromDateOrMonth(date) {
  const momentDate = moment(date);

  const dateFormatted = momentDate.format('YYYY-MM-DD');
  const datePlus = momentDate.clone().add(1, 'days').format('YYYY-MM-DD');

  const startOfMonth = momentDate.clone().startOf('month').format('YYYY-MM-DD');
  const endOfMonth = momentDate.clone().endOf('month').format('YYYY-MM-DD');
  const endMonthPlus = momentDate.clone().endOf('month').add(1, 'days').format('YYYY-MM-DD');

  return { momentDate, dateFormatted, datePlus, startOfMonth, endOfMonth, endMonthPlus };
}

function getPeriodType(start, end) {
  const dateStart = moment(start);
  const dateEnd = moment(end);

  let periodType = '';
  let startFormatted = dateStart.format('YYYY-MM-DD');
  let endFormatted = dateEnd.format('YYYY-MM-DD');

  const daysDifference = dateEnd.diff(dateStart, 'days');

  const fromStartOfMonth = dateStart.date() === 1;
  const fromStartOfYear = dateStart.dayOfYear() === 1;

  const isSameMonth = dateStart.month() === dateEnd.month();
  const isSameYear = dateStart.year() === dateEnd.year();

  const isQuarterStart = dateStart.isSame(dateStart.clone().startOf('quarter'), 'day');
  const isQuarterEnd = dateEnd.isSame(dateEnd.clone().endOf('quarter'), 'day');
  const isSameQuarter = dateStart.quarter() === dateEnd.quarter();
  const isQuarter = isQuarterStart && isQuarterEnd && isSameYear && isSameQuarter;

  if (
    dateStart.day() === 0
    && daysDifference === 6
  ) {
    periodType = 'week';
  } else if (
    fromStartOfMonth
    && isSameMonth
    && isSameYear
    && dateEnd.isSame(moment(), 'day')
  ) {
    periodType = 'mtd';
  } else if (
    fromStartOfMonth
    && daysDifference === dateStart.daysInMonth() - 1
  ) {
    periodType = 'month';
  } else if (isQuarter) {
    periodType = 'quarter';
  } else if (
    fromStartOfYear
    && isSameYear
    && dateEnd.isSame(moment(), 'day')
  ) {
    periodType = 'ytd';
  } else if (
    fromStartOfMonth
    && dateStart.month() === 0
    && dateEnd.isSame(dateStart.endOf('year'), 'day')
  ) {
    periodType = 'year';
  } else if (daysDifference === 90) {
    periodType = 'last90days';
  }

  return { start: startFormatted, end: endFormatted, periodType };
}

function getDayDifference(startDate, endDate) {
  if (!(startDate instanceof Date) || !(endDate instanceof Date) || isNaN(startDate) || isNaN(endDate)) {
    throw new Error('Invalid date inputs');
  }

  const yearsDiff = endDate.getFullYear() - startDate.getFullYear();
  const monthsDiff = endDate.getMonth() - startDate.getMonth();
  const daysDiff = endDate.getDate() - startDate.getDate();
  const totalDays = yearsDiff * 365 + monthsDiff * 30 + daysDiff;

  return totalDays;
}

module.exports = {
  getFormattedDateMonthFromDateOrMonth,
  getPeriodType,
  validateDateRange,
  getDayDifference,
};
